import { render, staticRenderFns } from "./PartnerDetails.vue?vue&type=template&id=4c2ceb45&scoped=true&"
import script from "./PartnerDetails.vue?vue&type=script&lang=ts&"
export * from "./PartnerDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2ceb45",
  null
  
)

export default component.exports